export default `Am *29.01.2020 – 30.01.2020* habe ich Zeit und bin nicht anderweitig gebucht. [Ja]

Mit der genannten Gage, dem Buyout, den verbundenen Nutzungsrechten, sowie den Reisekosten wäre ich einverstanden. [!Ja]

Der Casting-Termin ist vereinbart (Termin als Bemerkung eingetragen). [Ja - freitext]

Aktuelles Pola / Selfie [upload]`;
